import React,{useRef} from "react";
import { useEffect } from "react";
import Breadcrumb1 from "../../Components/Breadcrumb1/Breadcrumb1";
import AllAcountsSection from "../../Components/AllAccountsSection/AllAcountsSection";


// import BackgroundBrundcrumb from "../../assets/images/IZB/BackgroundBrundcrumb.png";
import {
  AiOutlineArrowLeft,
  AiOutlineArrowRight,
  AiOutlineShareAlt,
} from "react-icons/ai";

import { Link } from "react-router-dom";
import { CiClock1 } from "react-icons/ci";
import { BiMessageDetail } from "react-icons/bi";
const LatestTariffsAndCharges = () => {
const BackgroundBrundcrumb = "https://izbassetsmain.blob.core.windows.net/izbwebassets/BackgroundBrundcrumb.png";
const storie1 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/11.png";
const storie2 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/12.png";
const storie3 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/12.png";
const storie21 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/q3twge.jpg";

const storie4 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/13.png";
const storie5 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/14.png";
const page1 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/11.png"
const arroww = "https://izbassetsmain.blob.core.windows.net/izbwebassets/chevron_right.svg";

const banner1 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/IZB_Savings_Products_2024_banner.png";
const link1 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/IZB_Savings_Products_2024.pdf"

const banner2 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/IZB_Forex_Products_2024_banner.png";
const link2 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/IZB_Forex_Products_2024.pdf"

const banner3 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/IZB_Forex_Other_Service_Charges_2024_banner.png";
const link3 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/IZB_Forex_Other_Service_Charges_2024.pdf"

const banner4 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/IZB_Digital_Banking_2024_banner.png";
const link4 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/IZB_Digital_Banking_2024.pdf"

const banner5 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/IZB_Current_Products_2024_banner.png";
const link5 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/IZB_Current_Products_2024.pdf"

const banner6 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/IZB_Advances_2024_banner.png";
const link6 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/IZB_Advances_2024.pdf"

const banner7 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/INDO_Premier_Account_2024_banner.png";
const link7 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/INDO_Premier_Account_2024.pdf"


  const sliderRef = useRef(null);
  // console.log(sliderRef.current);
  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 4,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <Breadcrumb1 Heading="LATEST TARIFFS AND CHARGES" Heading1="Indo Zambia Bank  |  July 26, 2025" img={BackgroundBrundcrumb} />
      <div className="text-center" style={{marginTop:"5rem",marginBottom:"5rem"}}>
        <div className="container">

        <p style={{fontSize:"18px", margin:"0px auto 80px", maxWidth: '90%' }}> Stay informed with IZB's latest tariffs and charges. Access comprehensive fee structures for personal and business banking services, loans, digital banking, and other transactions to help you make informed financial decisions.
        </p>

            <div className="row" style={{rowGap: '60px'}}>
                 <div className="col-xl-4 col-lg-4">
                    <a href={link1}>
                          <img src={banner1} alt="" />
                    </a>
                    <h4 className="mt-2">IZB Savings Products</h4>
                 </div>

                 <div className="col-xl-4 col-lg-4">
                    <a href={link2}>
                          <img src={banner2} alt="" />
                    </a>
                    <h4 className="mt-2">IZB Forex Products</h4>
                 </div>

                 <div className="col-xl-4 col-lg-4">
                    <a href={link3}>
                          <img src={banner3} alt="" />
                    </a>
                    <h4 className="mt-2">IZB Forex Other Service Charges</h4>
                 </div>

                 <div className="col-xl-4 col-lg-4">
                    <a href={link4}>
                          <img src={banner4} alt="" />
                    </a>
                    <h4 className="mt-2">IZB Digital Banking</h4>
                 </div>

                 <div className="col-xl-4 col-lg-4">
                    <a href={link5}>
                          <img src={banner5} alt="" />
                    </a>
                    <h4 className="mt-2">IZB Current Products</h4>
                 </div>

                 <div className="col-xl-4 col-lg-4">
                    <a href={link6}>
                          <img src={banner6} alt="" />
                    </a>
                    <h4 className="mt-2">IZB Advances</h4>
                 </div>

                 <div className="col-xl-4 col-lg-4">
                    <a href={link7}>
                          <img src={banner7} alt="" />
                    </a>
                    <h4 className="mt-4">INDO Premier Account</h4>
                 </div>

                 
            </div>
        </div>
      </div>
      <section>
      <div className="container">
        <div className="row">
          <div className="container">
            <div className="heading ">
              <h2 className="text-left" style={{color:"#9E1B1E",fontWeight:"450"}}>More to Explore</h2>
             
            </div>
            <div
              className="py-4"
              style={{ float: "right"}}
            >
         
            </div>
          </div>

          {/* <Slider ref={sliderRef} {...settings}>  */}
          
          <div className="col-xl-4 col-lg-4">
            <div
              className="single-blog-style1 wow fadeInUp"
              data-wow-delay="00ms"
              data-wow-duration="1500ms"
            >
                <a href="/Workerscopensation">
              <div className="img-holder">
                <div className="inner">
                  <img src={storie21} alt="" />
           
                    <div className="overlay-icon"></div>
              
                </div>
              </div>
              </a>
              <div className="text-holder">
                <h3 className="blog-title mt-4">
             
                  <a>IZB - Workers Compensation Fund Control Board Zambia E-Workers Smart Pay Launch
</a><br/>

                  <span style={{fontSize: "15px", color: "gray"}}>October 20, 2023</span>
                </h3>
                <p className="" style={{marginBottom:"0rem"}}>
                Indo Zambia Bank is proud to announce the launch of the provision of the E-Workers on our INDO Internet Banking platform .This Indo NXT Corporate Banking platform ...
                </p><br/>
                <Link
                to="/Workerscopensation">
             <h5 style={{fontWeight:"500", color:"#9E1B1E", textAlign:"right"}}>Read More <img src={arroww} alt="" width="8%"/></h5></Link>
             <hr style={{ color:"#9E1B1E", margin:"0rem 0"}}/>
            
              </div>
            </div>
          </div>
          <div className="col-xl-4 col-lg-4">
            <div
              className="single-blog-style1 wow fadeInUp"
              data-wow-delay="00ms"
              data-wow-duration="1500ms"
            >
           <a href="/Indopremierbanking">
              <div className="img-holder">
                <div className="inner">
                  <img src={storie5} alt="" />
            
                    <div className="overlay-icon"></div>
                
                </div>
              </div>
              </a>
              <div className="text-holder">
                <h3 className="blog-title mt-4">
                  <a>Introducing Indo Premier Banking Suite - Tailored To Meet Your Banking Needs</a><br/>
                  <span style={{fontSize: "15px", color: "gray"}}>July 15, 2023</span>
                </h3>
                <p className="" style={{marginBottom:"0rem"}}>
                We cordially invite you to the Indo Premier Banking Suite. 
At Indo Zambia Bank (IZB), we understand and appreciate that you, our valued customers ...
                </p><br/>
                <Link
                to="/Indopremierbanking">
             <h5 style={{fontWeight:"500", color:"#9E1B1E", textAlign:"right"}}>Read More <img src={arroww} alt="" width="8%"/></h5></Link>
             <hr style={{ color:"#9E1B1E", margin:"0rem 0"}}/>
            
              </div>
            </div>
          </div>
          <div className="col-xl-4 col-lg-4">
            <div
              className="single-blog-style1 wow fadeInUp"
              data-wow-delay="00ms"
              data-wow-duration="1500ms"
            >
             <a href="/Officiallaunchofizbhq">
              <div className="img-holder">
                <div className="inner">
                  <img src={storie2} alt="" />
           
                    <div className="overlay-icon"></div>
              
                </div>
              </div>
              </a>
              <div className="text-holder">
                <h3 className="blog-title mt-4">
                  <a>The Official Launch Of The New Indo House Corporate Head Office</a><br/>
                  <span style={{fontSize: "15px", color: "gray"}}>July 6, 2023</span>
                </h3>
                <p className="" style={{marginBottom:"0rem"}}>
                The Board, Management and Staff of the Indo Zambia Bank wish to extend their sincere gratitude to the President of the Republic of Zambia ...
                </p><br/>
                <Link
                to="/Officiallaunchofizbhq">
             <h5 style={{fontWeight:"500", color:"#9E1B1E", textAlign:"right"}}>Read More <img src={arroww} alt="" width="8%"/></h5></Link>
             <hr style={{ color:"#9E1B1E", margin:"0rem 0"}}/>
            
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
      <AllAcountsSection />
    </>
  );
};

export default LatestTariffsAndCharges;
